onLoad(() => {
    ['4808', '2696'].forEach((profileId) => {
        (function (c, p, d, u, id, i) {
            id = ''; // Optional Custom ID for user in your system
            u = 'https://tracking.g2crowd.com/attribution_tracking/conversions/' + c + '.js?p=' + encodeURI(p) + '&e=' + id;
            i = document.createElement('script');
            i.type = 'application/javascript';
            i.async = true;
            i.crossorigin = 'crossorigin';
            i.src = u;
            d.getElementsByTagName('head')[0].appendChild(i);
        }(profileId, document.location.href, document));
    })
});
